import axios from '@/plugins/axios'
import { errorResponse, successResponse } from '@/plugins/axios/utils'
import webStorage from '../../../store/webStorage/helper'

const serverURL = process.env.BACKEND_URL

const baseURL = `${serverURL}/v2/users`

export function getUserProfile () {
  return axios.get(`${baseURL}/profile`, {
    headers: {
      'istaging-token-type': 'istaging',
      'istaging-token': webStorage.getItem(`session-token-${process.env.NODE_ENV}`)
    }
  })
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}

export function getUserPublicProfile (id) {
  return axios.get(`${baseURL}/${id}/publicProfile`)
    .then(res => successResponse(res.data))
    .catch(err => errorResponse(err))
}
